import React from 'react';
import { Link } from 'react-router-dom';

import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import Alert from 'reactstrap/lib/Alert';

import { receiveTickets, requestLocations, receiveProducts } from '@ttstr/actions';
import { getLocationFromProduct } from '@ttstr/reducers/locations';
import { useActions, useShallowEqualSelector } from '@ttstr/utils';
import { AppState } from '@ttstr/reducers';

import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';

import { ContentrArea, Container, LoadingSpinner, Masonry, useIntl, MakiGIF } from '@ttstr/components';

const Home: React.FC = () => {
  const { t } = useTranslation();
  const { loading, products, tickets, locations, locationsReceived } = useShallowEqualSelector(mapStateToProps);
  const { receiveTickets, requestLocations, receiveProducts } = useActions(mapDispatchToProps);
  const { language } = useIntl();

  if (!locations) debugger;

  React.useEffect(() => {
    receiveTickets();
    requestLocations();
    receiveProducts();
  }, [language]);

  return (
    <article>
      <Helmet>
        <title>Bilderbuch</title>
        <body className="landing-page" />
      </Helmet>

      <div className="px-2">
        <h5 className="my-2">FILTERN:</h5>
        <Row className="px-2 mb-4 d-flex justify-items-start listing-buttons-container">
          <Col className="mt-2 px-2 col-auto">
            <Link to="/home" className="btn btn-outline-primary ">
              {'Alle Produkte'}
            </Link>
          </Col>
          <Col className="mt-2 px-2 col-auto">
            <Link to="/home?categoryId=3906" className="btn btn-outline-primary ">
              {'Tonträger'}
            </Link>
          </Col>
          <Col className="mt-2 px-2 col-auto">
            <Link to="/home?categoryId=4743" className="btn btn-outline-primary ">
              {'Merchandise'}
            </Link>
          </Col>
        </Row>

        {/* <h1 className="text-center my-4"> </h1> */}
        {loading ? ( // if loading
          <LoadingSpinner label={t(`LOADING.PRODUCTS`)} />
        ) : products.length === 0 ? ( // if no products
          <Alert color="info m-0">{t(`MASONRY.NO_ITEMS`)}</Alert>
        ) : (
          // else show products
          <Masonry
            id="product-listing"
            className="product-listing p-0"
            products={products.filter((p) => !p.tag_ids.includes(10428))}
            filters="off"
            showSubtitle
            rowClassName="row no-gutters"
            columnClassName="col"
            //            columnClassName="col-12 col-sm-6 col-md-4 col-xl-3"

            itemProps={{ overlay: true }}
            noResultsClassName="container-fluid my-4 text-info text-center"
          />
        )}

        {/* <Container className="list-page">
        <Helmet>
          <title>{t(`TICKETLISTING.TITLE`)}</title>
        </Helmet>

        <h1 className="text-center my-5">{t(`TICKETLISTING.TITLE`)}</h1>

        {loading ? ( // if loading
          <LoadingSpinner label={t(`LOADING.TICKETS`)} />
        ) : tickets.length === 0 ? ( // if no tickets
          <Alert color="info">{t(`MASONRY.NO_ITEMS`)}</Alert>
        ) : (
          // else show tickets
          <Masonry id="ticket-listing" products={tickets} type="list" showLocation showCity />
        )}
      </Container> */}
      </div>
    </article>
  );
};

const mapStateToProps = (state: AppState) => {
  const { tickets, loading } = state.Tickets;
  const { locations, locationsReceived } = state.Locations;
  const { products } = state.Products;
  return {
    tickets,
    products,
    loading,
    locations,
    locationsReceived,
  };
};

const mapDispatchToProps = {
  receiveTickets,
  receiveProducts,
  requestLocations,
};

export default React.memo(Home);
